import { render, staticRenderFns } from "./photoPage.vue?vue&type=template&id=42570230&scoped=true&"
import script from "./photoPage.vue?vue&type=script&lang=js&"
export * from "./photoPage.vue?vue&type=script&lang=js&"
import style0 from "./photoPage.vue?vue&type=style&index=0&id=42570230&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42570230",
  null
  
)

export default component.exports